import { useMutation } from '@tanstack/react-query';
import { ApplicationLicenseResponse } from '../types/Agreement';
import { respondAgreement } from '../services/fn-api/Agreements';

export const useRespondAgreement = () => {
  return useMutation<void, Error, ApplicationLicenseResponse>({
    mutationFn: async (response: ApplicationLicenseResponse) => {
      return respondAgreement(response);
    },
  });
};
